module.exports = __webpack_public_path__ + "ce45966065a99a8c0d8360f44593ad25.svg";